<template>
  <div>
    <div class="d-flex justify-content-between mb-3 pb-1">
      <DateRange :update="dateRange" :startDate="filter.startDate" :endDate="filter.endDate" />
      <div>
        <b-button variant="primary" size="sm" @click="exportPDF" class="export-btn">
          {{ 'PDF' | i18n }}
        </b-button>
      </div>
    </div>
    <Table
      :update="getPage"
      :columns="columns"
      :rows="rows"
      :filter="filter"
      :update-filter="updateFilter"
      :loading-instance="loadingInstance"
      :set-loading-instance="setLoadingInstance"
      class="overflow-auto pr-1"
      table-name="plantInputTable"
      :additionalHtml="additionalHtml"
    />
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { AuthMixin } from '../../../../mixins';
import api from '../../../api';
import DateRange from '../../common/date-range';
import Table from '../../common/table';

export default {
  title: 'Anlageninput',
  components: { DateRange, Table },
  mixins: [AuthMixin],
  data() {
    return {
      plantInput: api.plantInput,
      loadingInstance: null,
      rows: [],
      filter: {
        page: 1,
        limit: 20,
        totalCount: 0,
        sortBy: '',
        sortOrder: '',
        searchQuery: '',
        startDate: moment().startOf('month').add(3, 'hour'),
        endDate: moment(),
      },
      totalWeight: 0,
      totalQuantity: 0,
      details: [
        {
          header: 'DETAILS',
          content: [
            { value: 'date', name: 'Date' },
            { value: 'avv', name: 'AVV' },
            { value: 'sort', name: 'Sorte' },
            { value: 'weight', name: 'Gewicht/t' },
            { value: 'quantity', name: 'Quantity' },
          ],
        },
      ],
      columns: [
        {
          field: 'date',
          title: this.$translate('Date'),
          key: '9',
          sortBy: '',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return <span>{moment('30.11.2023', 'DD.MM.yyyy').format('DD.MM.yyyy')}</span>;
          },
        },
        {
          field: 'avv',
          title: this.$translate('AVV'),
          key: '6',
          sortBy: '',
          align: 'left',
        },
        {
          field: 'sort',
          title: this.$translate('Sorte'),
          key: '3',
          sortBy: '',
          align: 'left',
        },
        {
          field: 'weight',
          title: this.$translate('Gewicht/t'),
          key: '35',
          sortBy: '',
          align: 'right',
          width: '200px',
          renderBodyCell: ({ row }, h) => {
            const weight = +row.weight;
            const tempWeight = weight.toFixed(2);
            return <div class={`status-cell`}>{Number(tempWeight).toLocaleString('de-De')}</div>;
          },
        },
        {
          field: 'quantity',
          title: this.$translate('Quantity'),
          key: '53',
          sortBy: '',
          align: 'right',
          width: '200px',
          renderBodyCell: ({ row }) => {
            return <span>{row.quantity}</span>;
          },
        },
      ],
      additionalHtml: `<div class='d-flex justify-content-end mb-3 pb-1 mt-3'><div style='width: 200px; padding: 10px; text-decoration: underline; text-align: end;'>0</div><div style='width: 200px; padding: 10px; text-decoration: underline; text-align: end;'>0</div></div>`,
    };
  },
  methods: {
    async getPage() {
      try {
        this.startLoading();
        const { page, limit, sortBy, sortOrder, searchQuery, startDate, endDate } = this.filter;
        const ctx = {
          page,
          limit,
          sortBy,
          sortOrder,
          searchQuery,
        };
        if (startDate) {
          ctx.startDate = moment(startDate).format('yyyy-MM-DD');
        }
        if (endDate) {
          ctx.endDate = moment(endDate).format('yyyy-MM-DD');
        }
        const response = await this.plantInput.get(ctx);
        this.filter.totalCount = response.totalCount;
        this.stopLoading();

        this.rows = response.data;
        let weight = 0;
        let quantity = 0;
        response.data.forEach((item) => {
          weight = weight + +item.weight;
          quantity = quantity + +item.quantity;
        });

        this.totalWeight = weight;
        this.totalQuantity = quantity;
        this.additionalHtml = `<div class='d-flex justify-content-end mb-3 pb-1 mt-3'><div style='width: 200px; padding: 10px; text-decoration: underline; text-align: end;'>${Number(
          weight.toFixed(2)
        ).toLocaleString(
          'de-De'
        )}</div><div style='width: 200px; padding: 10px; text-decoration: underline; text-align: end;'>${quantity.toLocaleString(
          'de-De'
        )}</div></div>`;
      } catch (err) {
        // this.showNotification({ type: 'error', message: err.message });
        console.log('err', err);
      }
    },
    updateFilter(f) {
      this.filter = {
        ...this.filter,
        ...f,
      };
    },
    setLoadingInstance(loadingInstance) {
      this.loadingInstance = loadingInstance;
    },
    startLoading() {
      this.loadingInstance.show();
    },
    stopLoading() {
      this.loadingInstance.close();
    },
    dateRange(d) {
      this.filter.startDate = d.startDate;
      this.filter.endDate = d.endDate;
      this.getPage();
    },
    async exportPDF() {
      try {
        const { page, limit, sortBy, sortOrder, searchQuery, startDate, endDate } = this.filter;
        const ctx = {
          page,
          limit,
          sortBy,
          sortOrder,
          searchQuery,
        };
        if (startDate) {
          ctx.startDate = startDate;
        }
        if (endDate) {
          ctx.endDate = endDate;
        }
        const baseUrl = axios.defaults.baseURL;
        const auth = this.authStorageService.getAuth();
        const token = auth.access_token;

        fetch(
          `${baseUrl}/api/v1/gmva/plant-input/pdf?page=${page}&limit=${limit}&sortBy=${sortBy}&sortOrder=${sortOrder}&searchQuery=${searchQuery}&startDate=${startDate}&endDate=${endDate}&title=plantInput`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
          .then((resp) => resp.blob())
          .then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = `${moment().format('yyyy-MM-DD')}_Anlageninput.pdf`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            // this.showNotification({ type: 'success', message: this.$translate('file_has_been_downloaded_successful') });
          })
          .catch((err) => {
            console.log('error', err);
          });
      } catch (err) {
        console.log('err', err);
      }
    },
  },
};
</script>

<style lang="scss"></style>
